import { HomePageComponent } from './home-page/home-page.component';
import { PaymentComponent } from './payment/payment.component';
import { PlansComponent } from './plans/plans.component';
import { SignupSuccessComponent } from './signup-success/signup-success.component';
import { SignupComponent } from './signup/signup.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { MsSignupSuccessComponent } from './ms-signup-success/ms-signup-success.component';

import { AuthGuardService } from './common-service/auth-guard/auth-guard.service';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { FreeTrialComponent } from './free-trial/free-trial.component';



const routes: Routes = [{path: '', component: HomePageComponent},
                        {path: 'signup/:id', component: SignupComponent},
                        {path: 'subscription-plans', component: SubscriptionPlansComponent},
                        {path: 'signup-success', component: SignupSuccessComponent},
                        {path: 'payment', component: PaymentComponent, canActivate: [AuthGuardService]},
                        {path: 'premium-plan', component: PlansComponent, canActivate: [AuthGuardService]},
                        {path: 'payment-success', component: PaymentSuccessComponent},
                        {path: 'verifyEmail/:customerId/:verificationCode', component: VerifyEmailComponent},
                        {path: 'ms-signup-response', component: MsSignupSuccessComponent},
                        {path: 'privacy-policy', component: PrivacyPolicyComponent},
                        {path: 'free-trial', component: FreeTrialComponent}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts